module.exports = __webpack_public_path__ + "img/title19_1.d60a7b0d.png";